// lemmaTagUtils.js
import { useState} from 'react';
import axios from 'axios';
import './StorePage.css'; // Import the CSS file
import './LemmaTagUtilstyle.css'
import {SpeakTextButton,LemmaAudioPlayer } from './LemmaPlayUtils';
import HanziCharacter from './CmnStrokeUtils';
export const getWordTags = (mapurl) => (
    <a
      href="_blank"
      className="spMapUrl"
      target="_blank"
      rel="noopener noreferrer"
      style={{ pointerEvents: 'none', cursor: 'default' }}
    >
      {
        (() => {
          try {
            const profile = JSON.parse(mapurl || '{}');
            const wordtags = profile.wordtags || [];
            const tags = wordtags.map(t => t.tag).join(', ');
            const datetime = profile.datetime;

            let formattedTime = '';
            if (datetime) {
              const date = new Date(datetime);
              formattedTime = date.toLocaleString('en-GB', {
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: false // ✅ 24-hour format
              });
            }

            return formattedTime 
            ? `${tags} · 🕒 ${formattedTime}`
            : tags;
          } catch (e) {
            return '';
          }
        })()
      }
    </a>
  );

export const PlayHeadword = ({ lemmaChs }) => {
  if (!lemmaChs) return null;

  try {
    const lemmaArray = typeof lemmaChs === 'string' ? JSON.parse(lemmaChs) : lemmaChs;
    if (Array.isArray(lemmaArray) && lemmaArray.length > 0) {
      const firstHeadword = lemmaArray[0].headword;
      if (firstHeadword && firstHeadword.aid && firstHeadword.value) {
        return (
          <LemmaAudioPlayer 
            aidurl={firstHeadword.aid} 
            aidtext={firstHeadword.value} 
          />
        );
      }
    }
  } catch (e) {
    console.error('Error parsing lemmaChs:', e);
  }

  return null;
};

export const AddWordProfileActions = ({ baseHostUrl, session, wordlemma,wordtags,langcodename = 'eng' }) => {
  const [wordTagsState, setWordTagsState] = useState(() => {
    try {
      const profile = JSON.parse(wordtags || '{}');
      return profile.wordtags || [];
    } catch (e) {
      return [];
    }
  });
  const currentTag = session?.usrprofile?.wordtag || 'default';
  const isTagged = wordTagsState.some(entry => entry.tag === currentTag);

  const handleToggleTag = async () => {
    try {
      const timestamp = new Date().toISOString();

      const updatedTags = isTagged
        ? wordTagsState.filter(entry => entry.tag !== currentTag)
        : [...wordTagsState, { tag: currentTag, datetime: timestamp }];

      const endpoint = isTagged ? 'remove-word-tag' : 'add-word-tag';
      await axios.post(`${baseHostUrl}/${endpoint}`, {
        username: session.username,
        langcode:langcodename,
        headword: langcodename === 'cmnbk'? wordlemma.displayNameDash:wordlemma.display_name,
        wordprofile: {
          wordtags: updatedTags,
          datetime: timestamp
        }
      }, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
      });

      setWordTagsState(updatedTags); // ✅ Reactively update UI
    } catch (error) {
      console.error('Error toggling tag:', error);
    }
  };

   return (
    <div className="spStoreHeader">
      <a
      href= "_blank"
      className="spStoreName"
      target="_blank"
      rel="noopener noreferrer"
      style={{ pointerEvents: 'none', cursor: 'default' }}
      >{wordlemma.display_name}</a>       
       <span className="spPrimaryTypeDisplayName">
        {langcodename !== 'cmnbk' ? `[${wordlemma.primaryTypeDisplayName}]` : ''}
        </span>
       {langcodename !=='cmnbk' && (
       <PlayHeadword lemmaChs={wordlemma.website} />
       )}
      <button
        className={`btn-tag-default ${isTagged ? 'tagged' : ''}`}
        onClick={handleToggleTag}
      >
        {isTagged ? `✅ ${currentTag}` : `➕ ${currentTag}`}
      </button>
     {/* --- NEW PART --- */}
      {/* Use your new HanziCharacter component here */}
      {/* It will automatically handle showing and animating the character */}
      {(langcodename==='cmn'|| langcodename==='cmnpe')&& 
      <HanziCharacter character={wordlemma.display_name} />}
    </div>
  );
};
